import React, { ReactNode, useContext } from 'react';
import c from 'classnames';

import { ReactComponent as Logo } from '@hvcgroep/design-system/assets/logo.svg';
import ModalContext from '../../contexts/ModalContext';
import Button from '../../../../shared/components/Button';

interface Props {
  className?: string;
  closeButtonText: string;
  children: ReactNode;
}

const Modal: React.FC<Props> = ({ className, closeButtonText, children }) => {
  const { updateModalOpen } = useContext(ModalContext);

  const classNames = c(
    'Modal',
    'overlay',
    className,
  );

  const handleModalClose = () => {
    document.body.classList.remove('js-disable-body-scrolling');
    updateModalOpen(false);
  };

  return (
    <div className={classNames}>
      <div className="layout-container">
        <nav className="navbar">
          <div className="container">
            <div className="region region-navigation">
              <div className="overlay__logo">
                <a
                  href="/"
                  title="Home"
                  className="site-logo"
                  onClick={handleModalClose}
                  aria-label="HVC logo"
                >
                  <Logo />
                </a>
              </div>

              <div className="overlay__close">
                <Button
                  type="secondary"
                  htmlType="button"
                  icon="close"
                  onClick={handleModalClose}
                >
                  {closeButtonText}
                </Button>
              </div>
            </div>
          </div>
        </nav>

        <div className="container main-container">
          <div className="row">
            <div className="col-12">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
